import { t, useLanguage } from '../i18n';
import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Import screens
import LoginScreen from '../screens/auth/LoginScreen';
import RegisterScreen from '../screens/auth/RegisterScreen';
import ForgotPasswordScreen from '../screens/auth/ForgotPasswordScreen';

const Stack = createNativeStackNavigator();

const AuthNavigator = () => {
  useLanguage();
  return (
    <Stack.Navigator
      initialRouteName="Login"
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="Login" component={LoginScreen} options={{ title: t("ログイン") }} />
      <Stack.Screen name="Register" component={RegisterScreen} options={{ title: t("新規登録") }} />
      <Stack.Screen name="ForgotPassword" component={ForgotPasswordScreen} options={{ title: t("パスワード再設定") }} />
    </Stack.Navigator>
  );
};

export default AuthNavigator;
